"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Post = void 0;
var create_entity_1 = require("../../utils/create-entity");
var post_details_layout_1 = require("../../components/entities/post-details-layout");
var post_details_banner_1 = require("../../components/entities/post-details-banner");
var graphql_1 = require("../../utils/graphql");
var entity_with_taxonomies_card_1 = require("../../components/entities/entity-with-taxonomies-card");
exports.Post = {
  name: 'Post',
  canEmbed: true,
  groupName: 'Content',
  autoRoutes: ['details', 'create', 'update', 'list'],
  useConnections: true,
  useSpaces: true,
  usePreview: true,
  useSlices: true,
  useSites: true,
  components: {
    details: post_details_layout_1.PostDetailsLayout,
    banner: post_details_banner_1.PostDetailsBanner,
    card: entity_with_taxonomies_card_1.EntityWithTaxonomiesCard
  },
  banner: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      subtitle\n    "], ["\n      subtitle\n    "])))
  },
  filters: {
    fields: {
      types: {
        entityTypeName: 'PostType'
      },
      challenges: {
        entityTypeName: 'Challenge'
      },
      trends: {
        entityTypeName: 'Trend'
      },
      topics: {
        entityTypeName: 'Topic'
      },
      subTopics: {
        entityTypeName: 'SubTopic'
      }
    }
  },
  includeInSearch: true,
  table: {
    fieldNames: ["info", "path", "updatedBy", "createdBy"]
  },
  list: {
    resultsVariant: 'grid',
    hasSearch: true,
    // Remove _DEFINITION_ page
    applyFilterState: function (state) {
      return __assign(__assign({}, state || {}), {
        filter: __assign({
          name: {
            ne: "_DEFINITION_"
          }
        }, state.filter || {})
      });
    },
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      openGraph { \n        id\n        description { id html text plain plainTruncated: plain(truncate: { words: 25 }) }\n        date\n        url\n        author\n        image { id url }\n       }\n       ...TaxonomyFields\n      sites { ...EntityValueFields }\n      summary { id text }\n      updatedBy { ...CreatorFields }\n      createdBy { ...CreatorFields }\n      path\n    "], ["\n      openGraph { \n        id\n        description { id html text plain plainTruncated: plain(truncate: { words: 25 }) }\n        date\n        url\n        author\n        image { id url }\n       }\n       ...TaxonomyFields\n      sites { ...EntityValueFields }\n      summary { id text }\n      updatedBy { ...CreatorFields }\n      createdBy { ...CreatorFields }\n      path\n    "])))
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      summary { text }\n      path\n      title\n      subtitle\n      pretitle\n      content { text  }\n      intro { text }\n      outro { text }\n\n      ...TaxonomyExportFields\n\n      types { name }\n      authors { name }\n      organisationAuthors { name }\n      people { name }\n      organisations { name }\n      feedEntries { name }\n      sites { name }\n    "], ["\n      summary { text }\n      path\n      title\n      subtitle\n      pretitle\n      content { text  }\n      intro { text }\n      outro { text }\n\n      ...TaxonomyExportFields\n\n      types { name }\n      authors { name }\n      organisationAuthors { name }\n      people { name }\n      organisations { name }\n      feedEntries { name }\n      sites { name }\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      summary { id text }\n      path\n      title\n      subtitle\n      pretitle\n      content { ...ContentNodeFields  }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n\n      ...TaxonomyFields\n\n      types { ...EntityValueFields }\n      authors { ...EntityValueFields }\n      organisationAuthors { ...EntityValueFields }\n      people { ...EntityValueFields }\n      imageAssets { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      sites { ...EntityValueFields url }\n\n      id slug path \n        name \n        title\n        pretitle\n        subtitle\n        published\n        edited\n        content { plain text }\n        openGraph { title description { plain } image { thumbnails { full { url url2x } } } }\n        intro { plain text }\n        outro { text }\n        imageAssets {\n          id name image { id url url2x }\n        }\n        organisations {\n          id name slug path\n          logo { id url url2x }\n        }\n        authors {\n          id name slug path\n          organisation { id name }\n          linkedin\n          photo { id url url2x }\n          positions {\n            id\n            primary\n            positions {\n              id \n              name \n            }\n            organisation { id name }\n          }\n        }\n        people {\n          id name slug path\n          organisation { id name }\n          linkedin\n          photo { id url url2x }\n          positions {\n            id\n            primary\n            positions {\n              id \n              name \n            }\n            organisation { id name }\n          }\n        }\n        embeds {\n          citations {\n            slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n          }\n          pages {\n            id name slug path\n            openGraph {\n              title description { plain }\n              image { url url2x }\n            }\n          }\n          people {\n            id name slug path\n            organisation { id name }\n            position\n            photo { id url }\n          }\n          imageAssets {\n            id\n            slug\n            image {\n              id url url2x width height\n            }\n          }\n        }\n        banners {\n          id name slug title description { text } alternateText\n          image { \n            id url url2x width height\n          }\n        }\n        \n    "], ["\n      summary { id text }\n      path\n      title\n      subtitle\n      pretitle\n      content { ...ContentNodeFields  }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n\n      ...TaxonomyFields\n\n      types { ...EntityValueFields }\n      authors { ...EntityValueFields }\n      organisationAuthors { ...EntityValueFields }\n      people { ...EntityValueFields }\n      imageAssets { ...EntityValueFields }\n      organisations { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      sites { ...EntityValueFields url }\n\n      id slug path \n        name \n        title\n        pretitle\n        subtitle\n        published\n        edited\n        content { plain text }\n        openGraph { title description { plain } image { thumbnails { full { url url2x } } } }\n        intro { plain text }\n        outro { text }\n        imageAssets {\n          id name image { id url url2x }\n        }\n        organisations {\n          id name slug path\n          logo { id url url2x }\n        }\n        authors {\n          id name slug path\n          organisation { id name }\n          linkedin\n          photo { id url url2x }\n          positions {\n            id\n            primary\n            positions {\n              id \n              name \n            }\n            organisation { id name }\n          }\n        }\n        people {\n          id name slug path\n          organisation { id name }\n          linkedin\n          photo { id url url2x }\n          positions {\n            id\n            primary\n            positions {\n              id \n              name \n            }\n            organisation { id name }\n          }\n        }\n        embeds {\n          citations {\n            slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n          }\n          pages {\n            id name slug path\n            openGraph {\n              title description { plain }\n              image { url url2x }\n            }\n          }\n          people {\n            id name slug path\n            organisation { id name }\n            position\n            photo { id url }\n          }\n          imageAssets {\n            id\n            slug\n            image {\n              id url url2x width height\n            }\n          }\n        }\n        banners {\n          id name slug title description { text } alternateText\n          image { \n            id url url2x width height\n          }\n        }\n        \n    "])))
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'content'
    }, {
      name: 'titles'
    }, {
      name: 'featured-content',
      intro: 'Setup {{LINKS}} to appear in a banner carousel or a card grid at the top of this {{POST}}.'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'library'
    }, {
      name: 'community'
    }, {
      name: 'options'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      authors: {
        type: 'linkedMultiple',
        label: 'Authors',
        entityTypeName: 'Person',
        fieldSet: 'overview'
      },
      organisationAuthors: {
        type: 'linkedMultiple',
        label: 'Organisation Authors',
        entityTypeName: 'Organisation',
        fieldSet: 'overview'
      },
      published: {
        type: 'date',
        updateArgs: 'auto: false',
        description: 'When was this {{POST}} published? Note: If not specified, the last update of this {{POST}} will be taken as the publish date',
        recommended: false
      },
      edited: {
        type: 'date',
        fieldSet: 'overview',
        description: 'When was this {{POST}} last edited? Note: the record will maintain an Updated date automatically, but this is useful if you\'d like to curate a last edited date for display on a website for example.',
        recommended: false
      },
      types: {
        type: 'linkedMultiple',
        entityTypeName: "PostType",
        description: 'What type(s) of {{POST}} is this?',
        recommended: false
      },
      banners: {
        type: 'banner',
        isMulti: true,
        fieldSet: 'overview',
        recommended: false,
        description: 'Provide one or more {{BANNERS}} for this {{POST}}, if required'
      },
      summary: {
        type: 'longText',
        height: '40px',
        description: 'Provide a concise summary of this {{POST}} which is shown in cards and listings (this takes priority over Intro and Content for listings).',
        recommended: false
      },
      intro: {
        type: 'longText',
        height: '80px',
        recommended: false,
        fieldSet: 'content'
      },
      content: {
        type: 'longText',
        height: '300px',
        recommended: true,
        fieldSet: 'content'
      },
      outro: {
        type: 'longText',
        height: '80px',
        fieldSet: 'content',
        recommended: false
      },
      title: {
        type: 'text',
        fieldSet: 'content',
        description: 'Provide an alternative title to use if the name field is not sufficient.'
      },
      subtitle: {
        type: 'text',
        fieldSet: 'content',
        description: 'Provide a subtitle if required. This is useful if the overall title needs to be broken into two parts.'
      },
      pretitle: {
        type: 'text',
        fieldSet: 'content',
        description: 'Provide a title to display before the actual title. This might be useful for text which groups multiple pages into a section, where you still want the title field to represent the actual page title.'
      },
      bannerLinks: {
        label: 'Banner Links',
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        description: 'Setup {{{LINKS}} which might appear in a banner at the top of this {{POST}}',
        fieldSet: 'featured-content'
      },
      cardLinks: {
        label: 'Card Links',
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        description: 'Setup {{{LINKS}} which might appear in a card grid at the top of this {{POST}}, underneath any banner links',
        fieldSet: 'featured-content'
      },
      feedEntries: {
        type: 'linkedMultiple',
        label: 'Articles',
        entityTypeName: 'FeedEntry',
        fieldSet: 'library',
        description: 'Does this {{POST}} have any related {{FEED_ENTRIES}}?'
      },
      imageAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      },
      people: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        fieldSet: 'community'
      },
      organisations: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        fieldSet: 'community'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      }
    })
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;